import initExportMenu from './export';
import './table-filters';
import partyColors from './party-colors/party-colors';

window.SFP = {
    initExportMenu: initExportMenu,
    partyColors: partyColors
};